import { share, map } from 'rxjs/operators';
import { Observable, of, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class AirportsService {
  path: string = '/api';
  partnerId?: string;
  airports: any;
  airportGroups: any;
  airlineAirports: any;
  constructor(private apiService: ApiService) { }

  private observable1: Observable<any> | null = null;
  private observable2: Observable<any> | null = null;
  private observable3: Observable<any> | null = null;

  getAirportGroups(partnerId: string) {
    if (partnerId === this.partnerId && this.airportGroups) {
      return of(this.airportGroups);
    } else if (this.observable1) {
      return this.observable1;
    } else {
      this.observable1 = this.apiService
        .get(`${this.path}/airlines/${partnerId}/airport_group_suggestions`)
        .pipe(
          map((response: any) => {
            this.observable1 = null;
            this.partnerId = partnerId;
            this.airportGroups = response;
            return this.airportGroups;
          }),
          share(),
        );
      return this.observable1;
    }
  }

  getAirports(partnerId?: string) {
    if (partnerId === this.partnerId && this.airports) {
      return of(this.airports);
    } else if (this.observable2) {
      return this.observable2;
    } else {
      this.observable2 = (partnerId ? this.apiService.get(`${this.path}/partners/${partnerId}/airports`) : this.apiService.get(`${this.path}/airports`)).pipe(
        map((response: any) => {
          this.observable2 = null;
          this.partnerId = partnerId;
          this.airports = response;
          return this.airports;
        }),
        share(),
      );
      return this.observable2;
    }
  }

  getAirlineAirports(partnerId: string) {
    if (partnerId === this.partnerId && this.airlineAirports) {
      return of(this.airlineAirports);
    } else if (this.observable3) {
      return this.observable3;
    } else {
      const airports = this.apiService.get<any[]>(`${this.path}/partners/${partnerId}/airports`);
      const airlineAirports = this.apiService.get<{ airport_codes: string[] }>(`${this.path}/airlines/${partnerId}`);
      this.observable3 = forkJoin([airports, airlineAirports]).pipe(
        map((data) => {
          this.observable3 = null;
          this.partnerId = partnerId;
          this.airlineAirports = data[0].filter((airport: any) =>
            data[1].airport_codes.filter((code: string) =>
              code === airport.code).length > 0);
          return this.airlineAirports;
        }),
        share(),
      );
      return this.observable3;
    }
  }
}
